import { MatDialogRef } from '@angular/material/dialog';
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SurveyService } from '@service/survey.service';
import * as Cookies from "js-cookie";

@Component({
  selector: 'app-modal-satisfaction-survey',
  templateUrl: './modal-satisfaction-survey.component.html',
  styleUrls: ['./modal-satisfaction-survey.component.scss']
})
export class ModalSatisfactionSurveyComponent  {
  form = this.formBuilder.group({
    score: [1, [Validators.required]]
  })

  constructor(
    private formBuilder: FormBuilder,
    private surveyService: SurveyService,
    private dialogRef: MatDialogRef<ModalSatisfactionSurveyComponent>
  ) { }

  onSubmit(): void {
    this.surveyService.save(this.form.value).subscribe(res => {
      Cookies.set('isAnswered', 'true', { expires: 31, path: '/' });
      this.dialogRef.close();
    });
  }

}
